import { ModalContainer, ModalList, type ModalListItem } from 'src/components/ModalContainer';
import { ShortcutText } from 'src/components/ShortcutText/shortcut-text';
import { appShortcuts } from 'src/constants/appShortcuts';
import { Modals, useModalMethods, useModalState } from 'src/store/modals';

const SHORTCUT_ITEMS: ModalListItem[] = Object.entries(appShortcuts).map(([id, shortcut]) => ({
  id,
  title: shortcut.description,
  group: shortcut.categoryName,
  keywords: [shortcut.command],
  endAdornment: <ShortcutText shortcut={shortcut.command} />,
}));

export const ShortcutsModal = () => {
  const { isOpened } = useModalState(Modals.ShortcutsModal);
  const { closeModal } = useModalMethods(Modals.ShortcutsModal);

  return (
    <ModalContainer
      open={isOpened}
      size="medium"
      title="Keyboard shortcuts"
      onClose={closeModal}
      data-testid="shortcuts-modal"
    >
      <ModalList
        items={SHORTCUT_ITEMS}
        readOnly
        placeholder="Search shortcuts"
        emptyText="No shortcuts match."
        testId="shortcuts-modal"
      />
    </ModalContainer>
  );
};
